import "./src/assets/css/flags-light.css"
import "./src/assets/css/styles.css"
